import axios from "axios";

export function getCookie(name: string): string | null {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export function postJSON<Rsp>(
  url: string,
  payload: Record<string, unknown>
): Promise<{ data: Rsp }> {
  const csrftoken = getCookie("csrftoken");
  const safePayload: Record<string, unknown> = Object.assign(payload, {});

  const headers: Record<string, string> = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (csrftoken) {
    headers["X-CSRFToken"] = csrftoken;
  }

  return axios.post(url, safePayload, {
    headers,
  });
}

export function postData(url: string, blob: Blob, contentType: string) {
  const config = {
    headers: {
      "Content-Type": contentType,
      // "X-CSRFToken": getCookie("csrftoken"),
    },
  };
  return axios.put(url, blob, config);
}

export function postFile(
  url: string,
  fieldName: string,
  blob: Blob,
  extra?: Record<string, string>
) {
  const formData: FormData = new FormData();
  formData.append(fieldName, blob);
  if (extra) {
    for (const k of Object.keys(extra)) {
      formData.append(k, extra[k]);
    }
  }
  const config = {
    headers: {
      "Content-Type": "multipart/form-data; boundary=${data._boundary}",
      // "X-CSRFToken": getCookie("csrftoken"),
    },
  };
  return axios.post(url, formData, config);
}
